import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { ObjectManager } from '../../../concepts/objects';
import { MouseButtons, MouseInput } from '../../../platform/input/MouseInput';
import { EmojiStore, emojiToString } from '../../../ui/emoji';
import { resolve } from '../../Container';
import { Camera } from '../../canvas/Camera';
import { RelativeTo } from '../../canvas/entities/Physical';
import { defineToolWithCommonBehaviors } from '../../canvas/tooling/Definitions';
import { ToolBehavior, ToolSettings } from '../../canvas/tooling/ToolBehavior';
import { toolReset } from '../../canvas/tooling/ToolCommands';
import { GraffitiTarget } from '../../canvas/visualization/Graffiti';
import { EraserToolBehavior } from '../marker/EraserTool';
import { Token } from '../tokens/Token';
import { Reaction } from './Reaction';

class ReactionToolBehavior extends ToolBehavior {

    @resolve(Camera) private camera!: Camera;
    @resolve(ObjectManager) private objects!: ObjectManager;
    @resolve(CommandDispatcher) private dispatch: CommandDispatcher;

    private selectedEmoji: string = null!;

    public init(settings: ToolSettings) {
        this.selectedEmoji = settings.value;

    }

    public getPreferredCursor(state: string) {
        if (state === 'idle' || state === 'reacting') {
            return 'crosshair';
        }
    }

    public onMouseDown(state: string, mi: MouseInput): string | void {
        const { camera, objects, } = this;

        if (!this.selectedEmoji) {
            this.dispatch(toolReset);
            return;
        }

        if (state !== 'idle' || mi.button !== Number(MouseButtons.Main)) {
            return;
        }

        const subject = mi.targetPhysical;
        if (!subject) return;

        if (subject.is(GraffitiTarget)) {

            const mpt = camera.toModelPoint(mi.position);
            const rpt = subject.transform(RelativeTo.Model)
                .translate(subject.size().multiply(0.5))
                .inverse()
                .apply(mpt);

            objects.update(u => {
                const nr = u.create(Reaction);
                nr.origin = 'center';
                nr.x = rpt.x;
                nr.y = rpt.y;
                nr.value = this.selectedEmoji;
                subject.add(nr);
            });

        }
        else if (subject.is(Token)) {
            const emoji = EmojiStore.find(this.selectedEmoji);
            objects.update(() => subject.as(Token).value = emojiToString(emoji.id));
        }


        return 'reacting';
    }

    public onMouseUp(state: string, _mi: MouseInput): string | void {
        if (state === 'reacting') {
            return 'idle';
        }
    }
}

export const reactionTool = defineToolWithCommonBehaviors({
    id: 'reactionTool',
    label: 'Reactions',
    category: 'collaboration',
    icon: 'deqo://icons/d2/emoji',
    weight: 1060,
    behaviors: [
        EraserToolBehavior(MouseButtons.Secondary),
        ReactionToolBehavior,
    ]
});
